import { normalizeStateCode } from './wizardFieldValidation';

/** Use `wizard-button primary` for Continue / Generate. `btn-primary` stays green when disabled. */
export const WIZARD_PRIMARY_BUTTON_CLASS = 'wizard-button primary';

export const WIZARD_ANSWER_QUESTION_REASON = 'Answer this question to continue.';
export const WIZARD_COMPLETE_FIELDS_REASON = 'Complete the required fields to continue.';

export function formatRequiredFieldReason(labels, { verb = 'Enter' } = {}) {
  const items = (labels || []).map((label) => String(label || '').trim()).filter(Boolean);
  if (!items.length) return '';
  if (items.length === 1) return `${verb} ${items[0]} to continue.`;
  if (items.length === 2) return `${verb} ${items[0]} and ${items[1]} to continue.`;
  return WIZARD_COMPLETE_FIELDS_REASON;
}

export function formatMissingEmailsReason(names) {
  const people = (names || []).map((name) => String(name || '').trim()).filter(Boolean);
  if (!people.length) return '';
  if (people.length === 1) return `Enter a valid email for ${people[0]}.`;
  if (people.length === 2) return `Enter a valid email for ${people[0]} and ${people[1]}.`;
  return 'Enter a valid email for every person listed above.';
}

export function wizardBlockedReason({
  ready,
  missingLabels = [],
  verb = 'Enter',
  fallback = WIZARD_COMPLETE_FIELDS_REASON,
} = {}) {
  if (ready) return '';
  return formatRequiredFieldReason(missingLabels, { verb }) || fallback;
}

export function missingPropertyAddressLabels(data, fallbackState = '') {
  const missing = [];
  if (!String(data?.property_address || '').trim()) missing.push('street address');
  if (!String(data?.property_address_city || '').trim()) missing.push('city');
  if (!normalizeStateCode(data?.property_address_state || fallbackState)) missing.push('state');
  if (!/^\d{5}$/.test(String(data?.property_address_zip_code || '').trim())) {
    missing.push('ZIP code');
  }
  return missing;
}

export function missingPropertyAddressReason(data, fallbackState = '') {
  const missing = missingPropertyAddressLabels(data, fallbackState);
  if (!missing.length) return '';
  if (missing.length >= 4) {
    return 'Enter the property street, city, state, and ZIP to continue.';
  }
  return formatRequiredFieldReason(missing);
}
